import { zodValidator } from '@tanstack/zod-adapter';
import { PostsInsightSearchFilterSchema } from '@anytag/shared-organisms';
import { PostInsightDetailsSearchFilterSchema, PostsInsightDetails, PostsInsight, PermissionRoute } from '@anytag/app';
import { adminStaffAgencyPartnerAdvertiserRoles } from '@anytag/shared-constants';
import { PartialRouter } from '../../types';

export const PostsInsightRouter = {
  '/_private-routes/posts-insight': [
    () => <PermissionRoute permissions={adminStaffAgencyPartnerAdvertiserRoles} />,
    {}
  ],
  '/_private-routes/posts-insight/': [PostsInsight, { validateSearch: zodValidator(PostsInsightSearchFilterSchema) }],
  '/_private-routes/posts-insight/$id': [
    PostsInsightDetails,
    { validateSearch: zodValidator(PostInsightDetailsSearchFilterSchema) }
  ],
  '/_private-routes/posts-insight/$id/$postId': [
    PostsInsightDetails,
    { validateSearch: zodValidator(PostInsightDetailsSearchFilterSchema) }
  ]
} as const satisfies PartialRouter;
